module.exports = __webpack_public_path__ + "8b28525bdc1032286176c1e8ccb431d6.svg";